module.exports = __webpack_public_path__ + "static/media/right-arrow-disabled.b3a5ee7b.svg";